import { root } from './all-videos';

export const allVideos = {
  ...root,
};
